import focusRevealPNG from '~/assets/images/anatomyV2/focus-reveal-brain.png'
import focusRevealWEBP from '~/assets/images/anatomyV2/focus-reveal-brain.webp'
import InfoRevealTemplate from '~/pages/anatomyV2/libs/components/InfoRevealTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 6

const FocusRevealAnatomyV2 = (props: TPageProps) => (
  <InfoRevealTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    imageAlt="Brain, focus insight"
    imagePNG={focusRevealPNG}
    imageWEBP={focusRevealWEBP}
    paragraphI18nKeys={['onboarding.focusReveal.paragraph']}
    question="Focus reveal intro viewed"
    titleI18nKey="onboarding.focusReveal.title"
  />
)

export default FocusRevealAnatomyV2
